export default class FallbackHelper {
  static retry = async <T>(
    func: () => Promise<T>,
    { timeoutMs = 1000 } = {}) => {
    let response: T | void = void 0
    let shouldRetry = false

    try {
      response = await func()
    } catch (catchError) {
      shouldRetry = true
    }

    if (shouldRetry) {
      response = await new Promise((resolve, reject) => {
        setTimeout(async () => {
          try {
            const newResponse = await func()

            resolve(newResponse)
          } catch (error) {
            reject(error)
          }
        }, timeoutMs)
      })
    }

    return response
  }
}
